import { Row } from "@components/Flex";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body } from "@components/Typography";
import { LinearChartSelection } from "@ctypes";
import { usePerformanceChart } from "@hooks";
import { useStyles } from "./styles";

export const PerformanceChartFooter = () => {
  const styles = useStyles();

  const { selectedTimeRange, setSelectedTimeRange, data } = usePerformanceChart();

  const timeRanges = Object.keys(data) as Array<LinearChartSelection>;

  return (
    <>
      <Row style={styles.container}>
        {timeRanges.map((timeRange: LinearChartSelection) => {
          const item = data[timeRange];

          const { label, valid } = item;

          const isSelected = timeRange === selectedTimeRange;
          const isDisabled = !valid && timeRange !== "oneDay";

          const containerStyle = isSelected ? styles.selectedItem : styles.item;
          const textStyle = isSelected ? styles.selectedText : styles.text;
          const disabledStyle = isDisabled ? styles.disabled : null;

          return (
            <div
              key={label}
              style={containerStyle}
              onClick={() => {
                if (isDisabled) return;
                setSelectedTimeRange(timeRange);
              }}
            >
              <Body style={{ ...textStyle, ...disabledStyle }}>{label}</Body>
            </div>
          );
        })}
      </Row>

      <Spacing size={SpacingSizes.M} />
    </>
  );
};
